import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { studyIcon } from '../../../assets/images';
import './smart-lesson-catalog.scss';

export interface SmartLessonItem {
  lessonId: number;
  topicName: string;
  subTopicName?: string;
  levelName: string;
  topicId: number;
  levelId: number;
  subTopicId: number;
}

interface SmartLessonCatalogProps {
  items: SmartLessonItem[];
  introText?: string;
}

const SmartLessonCatalog: React.FC<SmartLessonCatalogProps> = ({ items, introText }) => {
  const { t } = useTranslation();
  const topicName = items.length > 0 ? items[0].topicName : '';
  const displayTitle = t('v2SmartCatalog_title_template', { topicName });

  return (
    <div className="smart-lesson-catalog">
      {introText && (
        <p className="smart-lesson-catalog__intro">{introText}</p>
      )}
      <p className="smart-lesson-catalog__title">
        {displayTitle}
      </p>
      <div className="smart-lesson-catalog__grid">
        {items.map((item) => {
          const displayTopic = item.subTopicName && item.subTopicName !== 'NULL' && item.subTopicId !== -1
            ? `${item.topicName} - ${item.subTopicName}`
            : item.topicName;

          return (
            <Link
              key={item.lessonId}
              to="/play-lesson"
              state={{
                lessonId: item.lessonId,
                topicName: item.topicName,
                levelName: item.levelName,
                topicId: item.topicId,
                levelId: item.levelId,
                subTopicId: item.subTopicId,
                resume: true,
                from: 'smartCatalog',
              }}
              className="smart-lesson-catalog__card"
              id={`smart-lesson-card-${item.lessonId}`}
            >
              <div className="smart-lesson-catalog__card-icon-container">
                <img src={studyIcon} alt="Study" className="smart-lesson-catalog__card-icon-img" />
              </div>
              <div className="smart-lesson-catalog__card-info">
                <h3 className="smart-lesson-catalog__card-title" title={displayTopic}>
                  {displayTopic}
                </h3>
                <span className="smart-lesson-catalog__card-level">
                  {item.levelName}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default SmartLessonCatalog;
